import { Badge as AntdBadge } from 'antd'

export const Badge = AntdBadge
